import { atomWithStorage } from 'jotai/utils';

// Site-wide default building. Shown on first load and whenever the operator
// hasn't explicitly picked one yet. Buildings are stored lowercase in the DB
// (e.g. "pavilion", "pool", "farm").
export const DEFAULT_BUILDING_ID = 'pavilion';

// One shared, persisted building selection for the whole app. Using a single
// atom (instead of a per-page atom) is what makes the chosen building survive
// navigation between pages, and atomWithStorage makes it survive reloads too.
// Empty string means "not chosen yet" so callers fall back to the resolved
// default below.
export const selectedBuildingIdAtom = atomWithStorage<string>('fpm.selectedBuildingId', '');

/**
 * Building to default to when the operator hasn't picked one yet: prefer the
 * site default (pavilion, matched case-insensitively) when it exists, otherwise
 * the first building alphabetically. Returns null when no buildings are known.
 */
export function resolveDefaultBuildingId(buildingIds: string[]): string | null {
  if (!buildingIds.length) return null;
  const preferred = buildingIds.find((id) => id.toLowerCase() === DEFAULT_BUILDING_ID);
  if (preferred) return preferred;
  return [...buildingIds].sort((a, b) => a.localeCompare(b))[0];
}

// Dashboard-only building filter. Separate from the shared selection above so
// picking a building on the Power/Chargers pages doesn't change the dashboard,
// and vice versa. 'all' = every building at this site.
export const dashboardBuildingIdAtom = atomWithStorage<string>('fpm.dashboardBuildingId', 'all');
